import { render, staticRenderFns } from "./SysNoticeViewDialog.vue?vue&type=template&id=f40404a0&scoped=true"
import script from "./SysNoticeViewDialog.vue?vue&type=script&lang=js"
export * from "./SysNoticeViewDialog.vue?vue&type=script&lang=js"
import style0 from "./SysNoticeViewDialog.vue?vue&type=style&index=0&id=f40404a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40404a0",
  null
  
)

export default component.exports